import { atom } from 'recoil';

export const isTextSelectingAtom = atom<boolean>({
  key: 'isTextSelectingAtom',
  default: false,
});
